import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '../../core/services/loader/loader.service';
import { NotificationService } from '../../core/services/notification/notification.service';
import { SignUpService } from '../../core/services/signUp/signUp.service';
import { PopupService } from '../../shared/services/popup/popup.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'landing-app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class LandingFooterComponent implements OnInit {
  subscribeForm: FormGroup;
  constructor(
    private loaderService: LoaderService,
    private notification: NotificationService,
    private formBuilder: FormBuilder,
    private popupService: PopupService,
    private signupService: SignUpService,
    private errorhandlerService: ErrorhandlerService) {
    this.subscribeForm = this.formBuilder.group({
      UserName: ['', Validators.compose([Validators.required])],
      Email: ['', Validators.compose([Validators.required,
      Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,3})$')])]
    });
  }

  ngOnInit() {
  }

  onSubmit(subscribeForm: FormGroup) {
    let subscribeFormDetails = subscribeForm.value;
    if (subscribeForm.status == 'INVALID')
      this.notification.error('UserName and Email is required', 'Error');
    else {
      this.loaderService.show();
      this.signupService.subscribeNewsletter(subscribeFormDetails).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          //reset the form now.
          this.subscribeForm.reset({
            UserName: '',
            Email: ''
          });
          this.notification.success(res.Message, 'Subscribed');
        } else {
          this.notification.error(res.Message, 'Error');
        }
        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.errorhandlerService.handleError(err);
      });
    }
  }

  opensignupformDialog(): void {
    this.popupService.openSignUp();
  }

  openloginFormDialog(): void {
    this.popupService.openLogin();
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.subscribeForm.controls;
  }
}
